import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// import { EnvironmentService } from '../../../services/enviroment.service';
// import { environment } from '../../../services/global-environment';;

import { environment } from '../../../services/global-environment';

import { OpanaiService } from '../../../services/openai.service';

interface VersionRecord {
  id: number;
  content: string;
  timestamp: Date;
}

interface TemplateData {
  industry: string;
  content: string;
}

@Component({
  selector: 'app-basic-infomation',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './basic-infomation.component.html',
  styleUrl: './basic-infomation.component.scss'
})
export class BasicInfomationComponent implements OnInit {
  factoryInfo: string = '';
  versions: VersionRecord[] = [];
  currentVersion: number = 0;
  selectedFile: File | null = null;
  isAnalyzing: boolean = false;
  private apiUrl = environment.apiUrl;

  // Sample templates for different industry types
  industryTemplates: TemplateData[] = [
    {
      industry: '製造業',
      content: `公司名稱：[填寫公司名稱]
廠區位置：[填寫廠區地址]
廠區面積：[填寫面積] 平方公尺
員工人數：[填寫人數] 人
主要產品：[填寫產品]
生產製程：[描述主要製程]
使用的主要設備：[列出設備]
使用的主要原物料：[列出原物料]
廠區主要區域劃分：[描述區域劃分]`
    },
    {
      industry: '食品業',
      content: `公司名稱：[填寫公司名稱]
廠區位置：[填寫廠區地址]
廠區面積：[填寫面積] 平方公尺
員工人數：[填寫人數] 人
主要食品類別：[填寫食品類別]
生產線數量：[填寫數量]
冷藏/冷凍設備：[描述設備]
食品原料儲存方式：[描述儲存方式]
品質管制流程：[描述流程]
廠區清潔消毒方式：[描述方式]`
    },
    {
      industry: '醫療業',
      content: `公司名稱：[填寫公司名稱]
廠區位置：[填寫醫療機構地址]
廠區面積：[填寫面積] 平方公尺
員工人數：[填寫人數] 人
醫療服務類型：[描述服務類型]
床位數量：[填寫數量]
主要醫療設備：[列出設備]
醫療廢棄物處理方式：[描述處理方式]
無菌區域設置：[描述設置]
感染控制措施：[描述措施]`
    }
  ];

  constructor(private openaiService: OpanaiService) {}

  ngOnInit(): void {
    // Load saved data if available
    const savedData = localStorage.getItem('factoryInfo');
    const savedVersions = localStorage.getItem('factoryInfoVersions');

    if (savedData) {
      this.factoryInfo = savedData;
    }

    if (savedVersions) {
      this.versions = JSON.parse(savedVersions);
      this.currentVersion = this.versions.length;
    }
  }

  applyTemplate(industry: string): void {
    if (this.factoryInfo && !confirm('這將會覆蓋您目前輸入的資訊，確定要繼續嗎？')) {
      return;
    }

    const selectedTemplate = this.industryTemplates.find(template => template.industry === industry);
    if (selectedTemplate) {
      this.factoryInfo = selectedTemplate.content;
    }
  }

  saveFactoryInfo(): void {
    if (!this.factoryInfo.trim()) {
      alert('請輸入廠區基本資訊');
      return;
    }

    // Save to localStorage
    localStorage.setItem('factoryInfo', this.factoryInfo);

    // Create a new version
    const newVersion: VersionRecord = {
      id: this.currentVersion + 1,
      content: this.factoryInfo,
      timestamp: new Date()
    };

    this.versions.push(newVersion);
    this.currentVersion = newVersion.id;

    // Save versions to localStorage
    localStorage.setItem('factoryInfoVersions', JSON.stringify(this.versions));

    alert('資料已成功儲存');
  }

  loadVersion(versionId: number): void {
    const version = this.versions.find(v => v.id === versionId);
    if (version) {
      if (this.factoryInfo !== version.content &&
          !confirm('這將會覆蓋您目前輸入的資訊，確定要載入此版本嗎？')) {
        return;
      }
      this.factoryInfo = version.content;
      this.currentVersion = versionId;
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      // Now we just store the file reference, no analysis yet
    }
  }

  analyzeFile(): void {
    if (!this.selectedFile) {
      return;
    }

    this.isAnalyzing = true;

    // Clear previous content and add initial message
    this.factoryInfo = '開始分析文件，請稍候...\n';

    const prompt = `
公司名稱:泰山企業股份有限公司

請依照以下需求，從我提供的檔案內容中或Websearch中整理出完整資訊。如果找不到對應的欄位資料，請在答案中標示「未提及」或「無相關資料」。這些資訊將用於協助客戶判別相關法規適用範圍。

【企業基本資訊】
1. 公司名稱（中文與英文名稱）
2. 統一編號
3. 成立日期
4. 資本額
5. 實收資本額
6. 負責人姓名
7. 公司地址
8. 公司狀態（如：核准設立、解散、停業等）
9. 登記機關（如：經濟部商業司、科技部新竹科學園區管理局等）
10. 員工人數
11. 是否為上市櫃公司
12. 是否有跨境業務

【職業安全衛生資訊】
1. 行業別（第一類、第二類、第三類等）
2. 是否為危險性工作場所（是／否）
3. 班別型態（常日班、二班制、三班制、四班二輪制等）
4. 總機構總勞工人數（選項：500~1000人、1000~3000人、3000人以上…）
5. 事業單位總勞工人數（選項：未滿30、30~100、3000~6000人等）
6. 特別危害健康作業勞工人數（選項：未滿100人、100~300人、300人以上）
7. 勞工人數（男／女）
8. 有害物質作業（如：有機溶劑、鉛、缺氧、粉塵、特定化學物質等）
9. 特殊作業項目（如：潛水、高壓室內、小型鍋爐、吊掛作業等）
10. 生產性設備或機械（如：高空作業車、捲揚機、電焊機、營建車輛等）
11. 危險性機械操作項目（如：3T以上起重機、吊籠、營建用提升機操作等）
12. 危險性設備（如：甲／乙／丙級鍋爐、壓力容器、高壓氣體設備等）
13. 危險物品運輸（如：危險物品貨車、罐槽車載運等）
14. 是否設有職安衛單位
15. 是否有內部稽核制度
16. 是否定期進行職安衛教育訓練
17. 是否有職業災害通報機制
18. 是否有高風險作業
19. 是否有危害性化學品使用
20. 是否有個人防護具管理制度
21. 是否有健康檢查與管理制度
22. 是否識別並評估職安衛風險與機會
23. 是否建立法律法規識別與遵循機制
24. 是否設定職安衛目標與績效指標
25. 是否有員工參與與諮詢機制
26. 是否建立應變準備與回應計畫
27. 是否定期進行內部稽核與管理審查

【環境保護資訊】
1. 是否設有廢水處理設施
2. 是否設有廢氣處理設施
3. 是否有廢棄物分類與處理制度
4. 是否有環境影響評估報告
5. 是否有環境管理系統認證（如 ISO 14001 等）
6. 是否有能源管理制度
7. 是否有環境教育訓練制度
8. 是否識別並評估環境因素
9. 是否建立合規性義務識別與遵循機制
10. 是否設定環境目標與管理方案
11. 是否考慮產品生命週期觀點
12. 是否建立應變準備與回應計畫
13. 是否定期進行內部稽核與管理審查

【消防安全資訊】
1. 是否設有消防安全設備（如：滅火器、消防栓、自動灑水系統等）
2. 消防設備的維護與檢查制度（是否定期維護、檢查並保有紀錄）
3. 是否有火災警報與通報系統
4. 是否有避難逃生設施（出口指示、逃生動線與照明）
5. 是否進行消防演練
6. 是否指派消防管理人
7. 是否有消防安全計畫書
8. 是否申報建築物消防安全設備檢查
9. 是否涉及危險物品存儲
10. 是否曾發生火災紀錄

【整體注意事項】
- 若有關「危險性機械設備」、「女性員工」或「童工」等資訊，請一併整理。
- 所有整理後的結果，請以文字的方式呈現，不要用Json、markdown或表格，方便後續系統處理。
- 如有其他能協助判別適用法規的重要資訊，請一併提供。

`;

    // Use the service with file upload
    this.openaiService.chatwithOpenAIWithSteam(
      prompt,
      '', // No assistant needed
      '', // No response_id
      environment.companyid, // Get companyid from environment
      ['web_search'], // No toolname
      '', // No vector_store_id
      [], // No imageAttachments
      [this.selectedFile] // Pass the selected file
    ).subscribe({
      next: (data: string) => {
        try {
          const jsonData = JSON.parse(data);

          if (jsonData.type === 'response.output_text.delta' && jsonData.delta) {
            // Remove the initial message if this is the first response
            if (this.factoryInfo === '開始分析文件，請稍候...\n') {
              this.factoryInfo = '';
            }

            this.factoryInfo += jsonData.delta;
          }
        } catch (error) {
          console.error('Error parsing JSON data:', error);
        }
      },
      error: (error) => {
        console.error('API call failed:', error);
        this.factoryInfo += `\n分析失敗：${error.message || '未知錯誤'}`;
        this.isAnalyzing = false;
      },
      complete: () => {
        this.isAnalyzing = false;
      }
    });
  }
}
